/* import __COLOCATED_TEMPLATE__ from './form.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import canUserManageProject from 'seshy/utils/can-user-manage-project';

export default class PlaylistFormComponent extends Component {
  @service currentUser;
  @service router;
  @service store;

  @tracked _isEditing = false;

  get isEditing() {
    return this.args.isEditing || this._isEditing;
  }

  get isCancelable() {
    //console.log('isCancelable = ', this.args.playlist.isNew, !!this.args.cancelAction);
    return !this.args.playlist.isNew || !!this.args.cancelAction;
  }

  get showBounceControls() {
    //console.log('showBounceControls', this.args.playlist.bounce, this.args.showBounceControls)
    if (!this.args.playlist.bounce) {
      return false;
    }
    if (typeof this.args.showBounceControls !== 'undefined') {
      return this.args.showBounceControls;
    }

    return true;
  }

  get canManagePlaylist() {
    return canUserManageProject(this.currentUser, this.args.playlist);
  }

  @action
  addEntry(project) {
    let playlistEntry = this.store.createRecord('playlist-entry', {
      project,
      playlist: this.args.playlist,
      order: this.args.playlist.playlistEntries.length,
    });
    console.log('playlist', this.args.playlist)
    this.args.playlist.playlistEntries.push(playlistEntry);
  }

  @action
  markerUpdated() {
    console.log('markerUpdated');
    let newArray = [...this.args.playlist.markers];
    this.args.playlist.markers = [];
    this.args.playlist.markers = newArray;
  }

  @action
  getCursorTime() {
    console.log('calling getCursorTime', this.displayTime);
    return this.displayTime;
  }

  get sound() {
    return this.currentlyPlaying.getSound(this.args.playlist.bounce?.soundId);
  }

  get soundTime() {
    if (this.sound) {
      return this.sound?.position / 1000;
    }
    return null;
  }

  get displayTime() {
    return this.soundTime || this.currentAudioTime;
  }

  @action
  addMarker() {
    let newStart = 0;
    if (this.currentAudioTime) {
      newStart = this.currentAudioTime;
    }
    let newMarker = { start: newStart, end: null, isEditing: true };
    newMarker = this.args.playlist.createMarker(newMarker);
    this.markerUpdated();
  }

  @action
  setCurrentAudioTime(newTime) {
    //console.log('setCurrentAudioTime = ', newTime);
    this.currentAudioTime = newTime;
  }

  @action
  setAudioTime(newTime) {
    //console.log('setAudioTime =', newTime);
    this.currentAudioTime = newTime;
    if (this.sound) {
      this.sound.position = newTime * 1000;
    }
  }

  @action
  setBounce(bounce) {
    if (this.args.playlist.bounce) {
      this.args.playlist.bounce = null;
    }
    later(() => {
      this.args.playlist.bounce = bounce;
      this.args.playlist.projectVersion = bounce.projectVersion;
    });
  }

  @action
  captureOriginalMarkers() {
    this.originalMarkers = JSON.stringify(this.args.playlist.markers); //JSON.stringify(this.args.playlist.markers);
    //console.log('we are calling captureOriginalMarkers = ', this.originalMarkers)
  }

  @action
  startEditing(e) {
    e.preventDefault();
    //console.log('startEditing');
    this._isEditing = true;
    return false;
  }

  @action
  cancelEditing() {
    if (!this.args.playlist.isNew) {
      this.args.playlist.rollbackAttributes();
      this._isEditing = false;
    } else {
      if (this.args.cancelAction) {
        this.args.cancelAction();
      }
    }

    //later(this,this.createNewMarkers);
  }

  @action
  async savePlaylist() {
    if (this.args.saveAction) {
      this.args.saveAction();
    } else {
      this.args.playlist.setProjectIds();
      await this.args.playlist.save();
      this._isEditing = false;
    }

    if (this.args.afterSave) {
      this.args.afterSave(this.args.playlist);
    }
  }

  @action async closePlaylist(closeStatus) {}

  @action
  async startDeleting(e) {
    e.preventDefault();
    //console.log('startDeleting', this.args.commentDeleteAction);
    if (
      confirm(
        'Are you sure you want to delete this playlist and all the comments that are on it? There is no undo!',
      )
    ) {
      let comment = this.args.playlist;
      comment.deleteRecord();
      await comment.save();
      this.router.transitionTo('authenticated.playlists');
    }
  }
}
